import React, { useEffect, useRef, useState } from "react";

import TextField from "@mui/material/TextField";
import { ESRQuestionConfig } from "../../types/data";
import { useRemoteField } from "../../hooks/useRemoteField";

export const ESRTextBoxField = (props: ESRQuestionConfig) => {
	const { question_id, required, hint_value, field_options, locked, inline, show_initial_response, field_type} =
		props;
	const [value, setValue, setLocalValue] = useRemoteField(
		question_id,
		field_options.length > 0 ? field_options[0] : "",
	);

	const [focused, setFocused] = useState(false);

	// Temporary workaround to silence WAVE
	const textFieldRef = useRef<HTMLDivElement | null>(null);
	useEffect(() => {
		textFieldRef.current?.querySelectorAll("textarea").forEach((el) => {
			el.setAttribute("id", question_id);
		});
	});
	return (
		<TextField
			ref={textFieldRef}
			id={question_id}
			variant={inline ? "standard" : "outlined"}
			fullWidth
			multiline
			minRows={inline ? 1 : 5}
			maxRows={10}
			value={value}
			disabled={locked > 0}
			required={required}
			placeholder={(hint_value.length > 0 && show_initial_response == "x") ? hint_value : ""}
			onFocus={() => setFocused(true)}
			onChange={(e) => setLocalValue(e.target.value)}
			onBlur={(e) => {
				setValue(e.target.value.replace(/\n+$/g, ''), locked === -1);
				setFocused(false);
			}}
			InputProps={{
				sx: {
					"&.Mui-disabled": {
						background: "#0000000F",
					},
				},
				inputProps: {
					style: {
						resize: "both",
						overflow: "auto",
						minHeight: "20px",
					},
				},
			}}
		/>
	);
};
